import { render, staticRenderFns } from "./UserStandardAvatar.vue?vue&type=template&id=a23dc7cc&scoped=true&"
import script from "./UserStandardAvatar.vue?vue&type=script&lang=js&"
export * from "./UserStandardAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserStandardAvatar.vue?vue&type=style&index=0&id=a23dc7cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dc7cc",
  null
  
)

export default component.exports